"use client";
import { Link } from "@/components/CustomLink";
import Logo from "@/components/logo";
import { usePathname } from "next/navigation";
import React from "react";
import { useTranslation } from "@/hooks/translationContext";

export default function NavbarLogo() {
  const { t } = useTranslation();
  const pathname = usePathname();
  const isHomepage = pathname === "/";

  return (
    <Link title={t("layout-logo-home-link-title")} href={"/"} className="w-auto">
      <Logo useDesktopLogo={isHomepage} />
    </Link>
  )
}
